import { snackbar } from "@mobiscroll/react5";
import { useMemo, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { postMutation, } from "src/components/ApolloConnection/ApolloProviderComponent";
import { CREATE_PRESCRIPTION_PDF } from "src/components/graphql/GraphQLmutation";
import dayjs from 'dayjs';
import { fetchAppointmentDetails, fetchPatientDetails, selectAppointmentById, selectPatientById } from "src/features/consultation/consultationActions";
import { useDispatch, useSelector } from "react-redux";
import { getAppointmentDetails } from "./api"
// import { PRESCRIPTION_DOWNLOAD_PDF } from "src/components/graphql/GraphQLquery";

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

export default function usePrescriptionPdf() {
  let query = useQuery();
  const appointmentId = query.get("appointmentId");
  const { patientId } = useParams();

  const [isPdfDataLoading, setIsPdfDataLoading] = useState(null);
  const [prescriptionBase64, setPrescriptionBase64] = useState(null);
  const [patientName, setPatientName] = useState(null);
  const [appointmentDate, setAppointmentDate] = useState(null);
  const [pdfLink, setPDFLink] = useState(null);

  const clinicName = sessionStorage.getItem("clinicName");
  // const doctorId = sessionStorage.getItem("role-id");
  // const clinic_id = sessionStorage.getItem("clinic_id");
  // const dispatch = useDispatch();

  const user = useSelector((state) => state.user.user);

  const patientDetails = useSelector((state) => {
    // selectPatientById(state, patientId)
    const existingPatientList = state?.patients?.patientList?.data;

    if (!existingPatientList || !Array.isArray(existingPatientList)) return null;

    const patient = existingPatientList.find((patient) => patient.id === patientId);
    return patient || null;
  });

  const appointDetails = useSelector((state) => {
    // selectAppointmentById(state, appointmentId)
    const patientHistory = state?.consultation?.patientHistory;
    if (!patientHistory || !Array.isArray(patientHistory)) return null;

    const appointment = patientHistory.find((appt) =>
      appt?.appointmentDetails?.id === appointmentId
    );
    return appointment?.appointmentDetails || null;
  })

  const getAppointDetails = async (id) => {

    let appointmentData = appointDetails;
    if (!appointmentData) {
      appointmentData = await getAppointmentDetails({ id: id });
    }

    const modifiedData = JSON.parse(JSON.stringify(appointmentData));

    setAppointmentDate(modifiedData.start);

    if (modifiedData.note && modifiedData.note.heightUnits) {
      delete modifiedData.note.heightUnits;
    }

    if (modifiedData.note && modifiedData.note.patientComplaints && Array.isArray(modifiedData.note.patientComplaints)) {
      modifiedData.note.patientComplaints.forEach(complaint => {
        if (complaint.updatedBy) {
          delete complaint.updatedBy;
        }
      });
    }

    if (modifiedData.labTestReports) {
      delete modifiedData.labTestReports;
    }
    return modifiedData;
  }

  const getDate = date => {
    return dayjs(date).format('DD_MM_YYYY');
  }

  const fetchPdfBase64 = async (data) => {
    try {
      const _res = await postMutation(CREATE_PRESCRIPTION_PDF, data);

      if (_res?.data?.createPrescriptionPdf?.base64) {
        setPrescriptionBase64(`data:application/pdf;base64,${_res?.data?.createPrescriptionPdf?.base64}`);
        return _res?.data?.createPrescriptionPdf?.base64;
      } else {
        snackbar({ message: "Unable to prepare Prescription Pdf", color: "danger", });
        return null;
      }
    } catch (error) {
      snackbar({ message: "Unable to prepare Prescription Pdf", color: "danger", });
      return null;
    }
  };

  const fetchPdfData = async () => {
    setIsPdfDataLoading(true);
    snackbar({ message: "Please wait. Creating prescription pdf..", color: "success", });
    try {
      if (user && patientDetails && appointmentId) {

        let clinicDetails = { ...user?.clinicData };
        const { id, helplineNumber, planId, razorpayAccountId, ...clinicData } = clinicDetails;

        const temaplateData = {

          appointmentData: await getAppointDetails(appointmentId),
          clinicData: clinicData,

          doctorData: {
            firstName: user?.firstName,
            lastName: user?.lastName,
            signature: user?.signature,
            medicalRegistrationNumber: user?.medicalRegistrationNumber,
          },
          patientData: {
            firstName: patientDetails?.firstName,
            lastName: patientDetails?.lastName,
            dateOfBirth: patientDetails?.dateOfBirth,
            gender: patientDetails?.gender
          },
        };

        setPatientName(`${patientDetails?.firstName}_${patientDetails?.lastName}`);
        console.log('template data-->', temaplateData)
        let link = await fetchPdfBase64(temaplateData);
        return link;
      } else {
        snackbar({ message: "Missing required data for prescription", color: "danger", });
        return null;
      }
    } catch (error) {
      console.error("Error in fetchPdfData:", error);
      snackbar({ message: "Error preparing prescription", color: "danger" });
      return null;
    } finally {
      setIsPdfDataLoading(false);
    }
  };

  const downLoadPdf = async (prescriptionBase64, appointmentDate, patientName, download) => {
    if (prescriptionBase64) {
      const file_name = "prescription_" + patientName + "_" + getDate(appointmentDate) + ".pdf";
      const link = document.createElement("a");
      const linkSource = `data:application/pdf;base64,${prescriptionBase64}`;
      setPDFLink(linkSource);

      if (download) {
        link.href = linkSource;
        link.download = file_name;
        link.click();
        link.remove();
      }
    } else {
      snackbar({ message: "Please wait...Loading Data", color: "success", });
    }
  };

  const downloadPrescription = async (download = false) => {
    const base64 = await fetchPdfData();
    downLoadPdf(base64, appointmentDate, patientName, download);
  };

  return {
    downloadPrescription,
    isPdfDataLoading,
    fetchPdfData,
    prescriptionBase64,
    prescriptionPDFLink: pdfLink,
    prescriptionFileName: clinicName + "_Prescription_" + patientName + "_" + getDate(appointmentDate) + ".pdf",
  };
}
